<div class="empty-items">
  <div *ngFor="let item of emptyItems" class="empty-item fadeout"></div>
</div>